import { NotificationData } from 'src/modules/notifications/types/NotificationData';
import { createTrigger } from 'src/utils/createTrigger';

export const NOTIFICATION_SHOW = createTrigger<NotificationData, void>('NOTIFICATION_SHOW');

export const NOTIFICATION_HIDE = createTrigger<NotificationData['id'], void>('NOTIFICATION_HIDE');
